import type { TransactionCountDto } from "@/modules/finances/gateway/financeStatisticsDto"

type TransactionTotalsState = Omit<TransactionTotalsEntity, "totalCount">

export class TransactionTotalsEntity {
  succeededCount: number
  pendingCount: number
  pendingSepaDebitCount: number
  failedCount: number
  disputedCount: number
  refundedCount: number
  atCounterCount: number
  onlineCount: number
  totalCount: number // succeededCount + pendingCount + failedCount + disputedCount + refundedCount

  private constructor(transactionTotals: TransactionTotalsState) {
    this.succeededCount = transactionTotals.succeededCount
    this.pendingCount = transactionTotals.pendingCount
    this.pendingSepaDebitCount = transactionTotals.pendingSepaDebitCount
    this.failedCount = transactionTotals.failedCount
    this.disputedCount = transactionTotals.disputedCount
    this.refundedCount = transactionTotals.refundedCount
    this.atCounterCount = transactionTotals.atCounterCount
    this.onlineCount = transactionTotals.onlineCount
    this.totalCount =
      transactionTotals.succeededCount +
      transactionTotals.pendingCount +
      transactionTotals.pendingSepaDebitCount +
      transactionTotals.failedCount +
      transactionTotals.disputedCount +
      transactionTotals.refundedCount
  }

  static fromDto(dto: TransactionCountDto): TransactionTotalsEntity {
    return new TransactionTotalsEntity({
      succeededCount: dto.succeededCount,
      pendingCount: dto.pendingCount,
      pendingSepaDebitCount: dto.pendingSepaDebitCount,
      failedCount: dto.failedCount,
      disputedCount: dto.disputedCount,
      refundedCount: dto.refundedCount,
      atCounterCount: dto.atCounterCount,
      onlineCount: dto.onlineCount,
    })
  }
}
